<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
import status from '@/mixins/status'

export default {
  mixins: [status],
  name: 'App',
  metaInfo: {
    title: 'Painel Omnichannel'
  },
  computed: {
    status: function () {
      return this.$store.state.status
    }
  },
  methods: {
    handleIframeMessage (event) {
      const payload = event.data
      if (
        payload &&
        payload.origin === 'omnichannel' &&
        payload.type === 'command' &&
        payload.command === 'NOTIFY' &&
        payload.data &&
        payload.data.message
      ) {
        this.$message({
          message: payload.data.message,
          type: payload.data.type || 'info',
          duration: payload.data.duration || 3000
        })
      }
    }
  },
  mounted () {
    window.addEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handleIframeMessage)
  }
}
</script>
<style lang="scss" scoped>
  @import './assets/scss/global.scss';
</style>
